import {FormRepositoriesFactory} from '../Repositories/factory.js'
import {GetCaptchaStatusFormService} from './GetCaptchaStatusFormService.js'
import {GetSpecsFormService} from './GetSpecsFormService.js'

export class FormServicesFactory {
  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @return {GetSpecsFormService}
   * @property {HTTPFormRepository} repository
   * @property {specsFormValueObjectFactory} specsFormValueObjectFactory
   */
  static getSpecsFormService = ({config}) => {
    return new GetSpecsFormService({
      repository: FormRepositoriesFactory.hTTPFormRepository({config})
    })
  }

  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @return {GetCaptchaStatusFormService}
   * @property {HTTPFormRepository} repository
   */
  static getCaptchaStatusFormService = ({config}) => {
    return new GetCaptchaStatusFormService({
      repository: FormRepositoriesFactory.hTTPFormRepository({config})
    })
  }
}
